import { Container, Sprite } from '@pixi/react';
import { getGameImages } from '../../../helpers/getGameImages';
import { gameConfigurationStore } from '../../store/gameConfigurationStore';

export const GameBoard = () => {
    const { gameBoard } = getGameImages();

    const containerConfig = {
        x: gameConfigurationStore.reelsContainerParams.xInFigma,
        y: gameConfigurationStore.reelsContainerParams.yInFigma,
    }


    return (
        <Container {...containerConfig} name='GameBoardContainer'>
            <Sprite anchor={0} texture={gameBoard} />
        </Container>
    );
};
